import { Button } from '@/shared/Button';
import { Icon } from '@/shared/Icon';

interface SubmapItemProps {
  modelName: string;
  onOpenClick: () => void;
  onDownloadClick: () => void;
}

export const SubmapItem = ({
  modelName,
  onOpenClick,
  onDownloadClick,
}: SubmapItemProps): JSX.Element => (
  <div className="flex flex-row flex-nowrap items-center justify-between py-2">
    {modelName}
    <div className="flex flex-row flex-nowrap items-center">
      <Button
        data-testid="download-submap-button"
        variantStyles="quiet"
        className="mr-4 p-0"
        title="Download"
        onClick={onDownloadClick}
      >
        <Icon name="download" className="h-6 w-6 fill-font-500" />
      </Button>

      <Button
        variantStyles="secondary"
        className="h-6"
        data-testid={`${modelName}-open`}
        onClick={onOpenClick}
      >
        Open
      </Button>
    </div>
  </div>
);
